import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './TableRates.module.scss';

export const TablePayment = ({ isDark }) => {
  const { t } = useTranslation();

  const componentClasses = cn({
    [CN.component]: true,
    [CN.darkTable]: isDark,
  });

  return (
    <div data-bem="TablePayment" className={componentClasses}>
      <table className={CN.table}>
        <thead>
          <tr>
            <th>
              <div className={CN.tableHeader}>
                <Icon variant="moneyPaper" width="lg" variantInvert />
                <div className={CN.headerText}>{t('slickPay.tablePayment.paymentDate')}</div>
              </div>
            </th>
            <th>
              <div className={CN.tableHeader}>
                <Icon variant="buildingLibrary" width="lg" />
                <div className={CN.headerText}>{t('slickPay.tablePayment.receiveIdnBank')}</div>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{t('common.days.tuesday')}</td>
            <td className={CN.focus}>{t('common.days.wednesday')}</td>
          </tr>
          <tr>
            <td>{t('common.days.wednesday')}</td>
            <td className={CN.focus}>{t('common.days.thursday')}</td>
          </tr>
          <tr>
            <td>{t('common.days.thursday')}</td>
            <td className={CN.focus}>{t('common.days.friday')}</td>
          </tr>
          <tr>
            <td>{t('common.days.friday')}</td>
            <td className={CN.focus}>{t('common.days.monday')}</td>
          </tr>
          <tr>
            <td>{t('slickPay.tablePayment.saturdayAndSunday')}</td>
            <td className={CN.focus}>{t('common.days.monday')}</td>
          </tr>
          <tr>
            <td>{t('common.days.monday')}</td>
            <td className={CN.focus}>{t('common.days.tuesday')}</td>
          </tr>
        </tbody>
      </table>

      <div className={CN.subTitle}>
        {t('slickPay.tablePayment.note1')}
        <br />
        {t('slickPay.tablePayment.note2')}
      </div>
    </div>
  );
};
